/*       */

import { gql } from '@apollo/client';
import entitiesListRisedCommonQuery from 'graphql/entities/common/entitiesListRisedCommonQuery';

export default gql`
    query personListRisedQuery($startIndex: Int, $stopIndex: Int, $filterBy: [JSON], $orderBy: [JSON], $excludeBy: [JSON]) {
        count: count(dataType: "person", filterBy: $filterBy, excludeBy: $excludeBy)
        records: people(startIndex: $startIndex, stopIndex: $stopIndex, filterBy: $filterBy, orderBy: $orderBy, excludeBy: $excludeBy) {
            ${entitiesListRisedCommonQuery}
        }
    }
`;
